import { render, staticRenderFns } from "./Launch_page.vue?vue&type=template&id=132dda28&"
import script from "./Launch_page.vue?vue&type=script&lang=js&"
export * from "./Launch_page.vue?vue&type=script&lang=js&"
import style0 from "./Launch_page.vue?vue&type=style&index=0&id=132dda28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports